import { useEffect } from 'react';

export default function YMapPolygon(props) {
  const {
    instance,
    polygon,
  } = props;
  useEffect(() => {
    if (!instance?.geoObjects || !polygon) {
      return undefined;
    }
    instance.geoObjects.add(polygon);
    return () => {
      instance.geoObjects.remove(polygon);
    };
  }, [instance, polygon]);
  return null;
}
